import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import DropDown from '../CommonControlls/DropdownRendrer'
import AlertModal from '../CommonControlls/AlertModal';
import DatePicker from "react-datepicker";
import moment from "moment";

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class DistrictWiseTarget_Stats extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,

            startDate: new Date(),
            endDate: new Date(),

            data: [],

            status: false,

            DistrictLoader: false,
            Districtlist: [],
            DistrictId: 0,

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState({
            DistrictId: value
        })
    }

    render() {

        return (

            <div>
                <MainLayout/>
                <AlertModal  {...this.state.alertModalData} />
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={"Stats District Wise Target"} isShowAddBtn={false}/>
                    <div class="content col-md-12 col-lg-12 d-flex justify-content-center">

                        {/* <div class="PageHeader_Container">
                            <h2>{this.state.Id==0?"Add User":"Edit User"}</h2>
                        </div> */}

                        <div class="card col-md-8 col-lg-8">
                            <div class="card-body row">

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <form onSubmit={this.SubmitForm} novalidate>
                                        <div class="row">
                                            <div class="formInput_Container col-md-12 col-lg-12 col-12">
                                                <label for=""><span style={{color: "red"}}>* </span>District</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="DistrictId"
                                                    options={this.state.Districtlist}
                                                    val={this.state.DistrictId}
                                                    addPlaceholder=""
                                                    disabled={true}
                                                    loading={this.state.DistrictLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-6  col-md-6">
                                                    <label htmlFor="">Start Date</label>
                                                    <DatePicker
                                                        selected={this.state.startDate}
                                                        onChange={(date) => this.setState({startDate: date})}

                                                    />
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="">End Date</label>
                                                    <DatePicker
                                                        selected={this.state.endDate}
                                                        onChange={(date) => {
                                                            this.setState({
                                                                endDate: date
                                                            })
                                                        }}

                                                    />
                                                </div>
                                            </div>

                                            <div
                                                class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <button type="submit" id="Form_SaveBtn" class="btn btn_style1"
                                                >Search
                                                </button>
                                            </div>

                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="content col-md-12 col-lg-12 d-flex justify-content-center">

                        <div className="card col-md-8 col-lg-8">
                            <div className="card-body ">
                                {this.state.data.length === 0 ? 'Please Select start and end date' :
                                    this.state.data.map(d => (
                                        <>
                                            <p>Achieved: {d.achieved}</p>
                                            <p>Expected: {d.expected}</p>
                                            <p>Result Added: {d.resultAdded}</p>
                                            <p>Sample Transported: {d.sampleTransported}</p>
                                        </>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }

        Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
            this.setState({
                loggedinUser: user.id
            })
        })
    }

    componentDidMount() {
        var Id = Common.GetId()
        if (Id !== 0) {
            this.DistrictWiseTarget(Id)
        }

        this.SelectDistricts()
    }
    SubmitForm = (e) => {
        e.preventDefault()

        const formData = {
            DistrictwiseTargetId: this.state.Id,
            DistrictId: this.state.DistrictId,
            StartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
            EndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
        }
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, "GET", false,
            Common.BaseUrlAPI + "/api/Settings/GETDistrictWiseTargetsStats", formData, (resp) => {
                this.props.ShowLoader({Isloading: false})
                console.log(resp)
                if (resp.status === true) {
                    this.setState({
                        data: resp.data
                    })
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again."})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            })

    }

    SelectDistricts = () => {
        this.setState({DistrictLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_District, {isPaginate: false},
            (Result) => {
                if (Result.status === true) {
                    this.setState({
                        Districtlist: Result.data,
                        DistrictLoader: false
                    })
                } else {
                    this.setState({
                        DistrictLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    DistrictLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    DistrictWiseTarget = (id) => {
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.BaseUrlAPI + "/api/Settings/SelectDistrictWiseTargets", {}, (resp) => {
            if (resp.status) {
                const selected = resp.data.find(d => d.id === id)
                this.LoadDataInEditMode(selected)
            }
        })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            DistrictId: data.district_id,
        })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(DistrictWiseTarget_Stats);
